import * as React from 'react';
export const StepsContext = /*#__PURE__*/React.createContext(null);